import { Option } from 'types/select';
import { TeethExtraction } from 'types/TreatmentPlanning.types';

export const isFormattedTeethString = (value?: string): boolean => {
  if (!value?.trim()) return false;
  return value.split(',').every((part) => /^\d\.\d$/.test(part.trim()));
};

export const isPrimaryTeethString = (value?: string): boolean => {
  if (!value || !isFormattedTeethString(value)) return false;
  return value.split(',').some((part) => {
    const prefix = part.trim().charAt(0);
    return ['5', '6', '7', '8'].includes(prefix);
  });
};

export const splitTeethOrTextField = (value?: string) => {
  if (!value?.trim()) {
    return { teeth: undefined, text: '' };
  }
  if (isFormattedTeethString(value)) {
    return { teeth: value, text: '' };
  }
  return { teeth: undefined, text: value };
};

export const formatTeeth = (teeths?: TeethExtraction): string => {
  if (teeths) {
    const teethsArray = Object.entries(teeths).reduce((prev, [, value]) => {
      value?.length && prev.push(value?.map(({ value }) => value).toString());
      return prev;
    }, [] as string[]);
    return teethsArray.toString();
  }
  return '';
};

const returnTeethPosition = (teeth: string) => {
  switch (teeth.charAt(0)) {
    case '1':
    case '5':
      return 0;
    case '2':
    case '6':
      return 2;
    case '3':
    case '7':
      return 3;
    case '4':
    case '8':
      return 1;
    default:
      return 0;
  }
};

export const formatTeethsForController = (
  teeths: string | undefined | null
): TeethExtraction | undefined => {
  if (!teeths) return undefined;
  const [rightTop, rightBottom, leftTop, leftBottom] = teeths.split(',').reduce(
    (prev, current) => {
      const teethPosition = returnTeethPosition(current);
      prev[teethPosition].push({ value: current });
      return prev;
    },
    [[], [], [], []] as Option[][]
  );
  return { rightTop, rightBottom, leftTop, leftBottom };
};

export const getToothChartValues = (
  toothList?: {
    position?: string;
    value?: string;
  }[]
) => {
  const toothChart: Record<string, string> = {};
  toothList?.forEach((item) => {
    if (item?.position && item?.value) {
      toothChart[item.position] = item.value.slice(0, -2);
    }
  });
  return toothChart;
};
